import type { Action } from 'state/actions';

import type { UserNotification, UserNotificationMap } from './notification.model';

export function userNotificationsReducer(state: UserNotificationMap = [], action: Action): UserNotificationMap {
  switch (action.type) {
    case 'SHOW_NOTIFICATION':
      const notification = {
        id: action.id,
        title: action.title,
        content: action.content?.filter(c => !!c),
        details: action.details?.filter(d => !!d),
        level: action.level,
        closeAutomatically: action.closeAutomatically,
        minWidth: action.minWidth,
      } as UserNotification;
      return [notification, ...state];
    case 'DISMISS_NOTIFICATION':
      return state.filter(n => n.id !== action.id);
    default:
      return state;
  }
}
